import { usePage } from '@inertiajs/react';

interface PageProps {
    translations: Record<string, string>;
}

export function useTranslations() {
    const { translations } = usePage<PageProps>().props;

    const t = (key: string, replacements?: Record<string, string | number>): string => {
        let translation = translations[key] || key;

        // Handle pluralization
        if (translation.includes('|')) {
            const parts = translation.split('|');
            const count = replacements?.count as number;
            
            if (count !== undefined) {
                // Simple pluralization: use first part for 1, second part for other
                translation = count === 1 ? parts[0] : parts[1] || parts[0];
            } else {
                translation = parts[0];
            }
        }

        // Replace placeholders
        if (replacements) {
            Object.entries(replacements).forEach(([placeholder, value]) => {
                translation = translation.replace(`:${placeholder}`, String(value));
            });
        }

        return translation;
    };

    const choice = (key: string, count: number, replacements?: Record<string, string | number>): string => {
        return t(key, { ...replacements, count });
    };

    return { t, choice };
}